import * as Yup from 'yup';

const toppingsCategorySchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  position: Yup.number()
    .min(1, 'Please enter more than 1')
    .typeError('Must be Number'),
  // items: Yup.array().of(
  //   Yup.object().shape({
  //     code: Yup.string().required('Code is required.'),
  //     labelEn: Yup.string().required('English Label is required.'),
  //     labelAr: Yup.string().required('Arabic Label is required.'),
  //     price: Yup.number()
  //       .min(0, 'Please enter more than 0')
  //       .required('Price is required.')
  //       .typeError('Must be Number'),
  //     shapeItems: Yup.array().of(
  //       Yup.object().shape({
  //         shapeId: Yup.string().required('Shape is required.'),
  //         // sliced: Yup.string().required('Sliced Image is required.'),
  //         top: Yup.string().required('Top Image is required.'),
  //         front: Yup.string().required('Front Image is required.'),
  //       })
  //     ),
  //   })
  // ),
});

export default toppingsCategorySchema;
